import React from "react";
import { IncomeRateTable } from "./IncomeRateTable";
import { SpaceToggleComponent } from "../commons/SpaceToggleComponent";

export interface IMarketCapSpaceViewProps {
    data: any;
    isEditing: boolean;
    spaceId: string;
    handleUpdateData: (data: any) => void;
    handleInputChange: (field: string, value: any) => void;
}

interface RateTableProps {
    heading: string;
    handleUpdateData: (field: string, value: any) => void;
}

export const MarketCapSpaceView: React.FC<IMarketCapSpaceViewProps> = ({
    data,
    isEditing,
    spaceId,
    handleUpdateData,
    handleInputChange,
}) => {
    const commonProps = {
        isEditing,
        data,
        spaceId,
    };

    const rateTables: RateTableProps[] = [
        { heading: "Market cap rate", handleUpdateData: handleInputChange },
        { heading: "Vacancy", handleUpdateData },
        { heading: "Rental Rate", handleUpdateData },
    ];

    return (
        <>
            <SpaceToggleComponent
                data={data}
                isEditing={isEditing}
                spaceId={spaceId}
                handleInputChange={handleInputChange}
            />
            {rateTables.map(({ heading, handleUpdateData }, index) => (
                <React.Fragment key={heading}>
                    {index > 0 && <br />}
                    <IncomeRateTable
                        {...commonProps}
                        heading={heading}
                        handleUpdateData={handleUpdateData}
                    />
                </React.Fragment>
            ))}
        </>
    );
};
